import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './estilos/tokens.css';
import './estilos/componentes.css';
import { App } from './App.js';
import { aplicarTema, temaGuardado } from './lib/tema.js';

/* El tema se aplica ANTES de pintar, no en un efecto: hacerlo despues
   produce un destello del tema claro en quien usa el oscuro. */
aplicarTema(temaGuardado());

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Falta el nodo #raiz');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
